"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var ApiUser = /** @class */ (function (_super) {
    __extends(ApiUser, _super);
    function ApiUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RESET_PASSWORD = '/users/resetPassword';
        _this.GET_COIN_INFO = '/coin/getCurrentCoin';
        _this.GET_MY_DATA = '/api/v1/page/my';
        _this.GET_USER_COIN_HISTORY = 'api/v1/page/my/getUserEpisodePurchaseList';
        _this.UPDATE_USER_EPISODE_ORDER = '/users/setEpisodeOrder';
        _this.UPDATE_PASSWORD = '/users/changePassword';
        _this.UPDATE_NICKNAME = 'users/changename';
        _this.DELETE_USER = 'users/delete';
        _this.GLOBAL_INFO = 'api/v2/global/user';
        /**
         * 비밀번호 찾기
         * @param loginId
         * @returns
         */
        _this.findPassword = function (loginId) {
            var data = {
                loginId: loginId,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: '' },
                method: 'post',
                url: _this.RESET_PASSWORD,
                data: data,
            });
        };
        /**
         * user coin 정보
         * @param token
         * @returns
         */
        _this.getCoinInfo = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.GET_COIN_INFO,
            });
        };
        /**
         * 마이페이지 데이터 획득
         * @param token
         * @param offset
         * @returns
         */
        _this.getMyData = function (token, offset) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, offset: offset },
                method: 'get',
                url: _this.GET_MY_DATA,
            });
        };
        /**
         * user coin history
         * @param token
         * @param language
         * @param offset
         */
        _this.getUserCoinHistory = function (token, offset) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, offset: offset },
                method: 'get',
                url: _this.GET_USER_COIN_HISTORY,
            });
        };
        /**
         * 사용자 회차리스트 기본 정렬 api
         * @param token
         * @param episodeOrder
         * @returns
         */
        _this.updateUserEpisodeOrder = function (token, episodeOrder) {
            var data = {
                episodeOrder: episodeOrder,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UPDATE_USER_EPISODE_ORDER,
                data: data,
            });
        };
        /**
         * 사용자 패스워드 업데이트 api
         * @param token
         * @param currentPassword
         * @param newPassword
         */
        _this.updateUserPassword = function (token, currentPassword, newPassword) {
            var data = {
                currentPassword: currentPassword,
                newPassword: newPassword,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UPDATE_PASSWORD,
                data: data,
            });
        };
        /**
         * 사용자 nickname 업데이트 api
         * @param token
         * @param name
         * @returns
         */
        _this.updateNickName = function (token, name) {
            var data = {
                name: name,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UPDATE_NICKNAME,
                data: data,
            });
        };
        /**
         * 회원탈퇴
         * @param token
         * @param userId
         * @returns
         */
        _this.deleteUser = function (token, userId) {
            var data = {
                userId: userId,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                url: _this.DELETE_USER,
                method: 'post',
                data: data,
            });
        };
        /**
         * loginCount + getCurrentCoin + globalProcess API
         * @param token
         * @returns
         */
        _this.getGlobalInfo = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                url: _this.GLOBAL_INFO,
                method: 'post',
            });
        };
        return _this;
    }
    ApiUser.getInstance = function (initValue) {
        if (!ApiUser.classInstance) {
            this.classInstance = new ApiUser(initValue);
        }
        return this.classInstance;
    };
    return ApiUser;
}(ApiManager_1.ApiManager));
exports.default = ApiUser;
